module.exports = __webpack_public_path__ + "img/cart.8e7417ac.svg";